<button
  mat-flat-button
  (click)="toggleSidenav()"
  class="active-filters-widget"
  *ngIf="showFiltersToggle"
>
  <div class="container">
    <mat-icon
      class="icon"
      [matBadge]="activeFilters?.query?.rules?.length || null"
      matBadgeColor="warn"
      >filter_alt
    </mat-icon>
    <span class="active-filters-label hide--xs show">Filters</span>
  </div>
</button>
